var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_35",
    "data-name": "Grupo 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.803,
    height: 157.32,
    viewBox: "0 0 127.803 157.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_83",
    "data-name": "Ret\\xE2ngulo 83",
    width: 127.803,
    height: 157.32,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_196",
    "data-name": "Caminho 196",
    d: "M50.534,11.033A39.965,39.965,0,1,0,90.125,51,39.777,39.777,0,0,0,50.534,11.033M71.678,44.214l-11.323,9.2a.556.556,0,0,0-.187.578l3.755,14.1a.558.558,0,0,1-.842.611L50.834,60.767a.561.561,0,0,0-.6,0L37.982,68.7a.557.557,0,0,1-.84-.611l3.755-14.1a.562.562,0,0,0-.189-.578l-11.323-9.2a.557.557,0,0,1,.322-.989l14.567-.784a.561.561,0,0,0,.489-.358l5.248-13.61a.557.557,0,0,1,1.04,0L56.3,42.083a.564.564,0,0,0,.491.358l14.565.784a.557.557,0,0,1,.322.989",
    transform: "translate(13.37 13.481)",
    fill: "#14e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_197",
    "data-name": "Caminho 197",
    d: "M51.338,62.548l-11.5,28.739L26.9,77.281,7.954,78.288,18.571,51.767",
    transform: "translate(9.72 63.256)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_198",
    "data-name": "Caminho 198",
    d: "M30.039,62.548l11.5,28.739L54.48,77.281l18.942,1.007L62.806,51.767",
    transform: "translate(36.706 63.256)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_199",
    "data-name": "Caminho 199",
    d: "M123.5,62.95c0,3.142-5.655,5.793-6.124,8.8-.48,3.086,4.077,7.366,3.142,10.274-.949,2.955-7.137,3.713-8.521,6.446-1.4,2.76,1.62,8.263-.171,10.752s-7.919,1.291-10.079,3.471-.969,8.357-3.444,10.177-7.912-1.24-10.648.169c-2.7,1.4-3.457,7.644-6.388,8.6-2.877.944-7.121-3.657-10.177-3.171-2.977.469-5.606,6.179-8.715,6.179s-5.739-5.71-8.715-6.179c-3.057-.487-7.3,4.115-10.179,3.171-2.931-.96-3.68-7.2-6.384-8.6-2.735-1.409-8.188,1.638-10.652-.171s-1.28-7.995-3.44-10.177-8.281-.971-10.081-3.473c-1.8-2.486,1.222-7.988-.176-10.748-1.384-2.733-7.57-3.491-8.519-6.45-.935-2.906,3.622-7.184,3.142-10.27C6.9,68.742,1.25,66.089,1.25,62.95s5.653-5.79,6.122-8.8c.48-3.084-4.084-7.364-3.142-10.27.949-2.957,7.135-3.72,8.519-6.45,1.393-2.762-1.624-8.261.169-10.75s7.924-1.3,10.083-3.475.962-8.355,3.44-10.174,7.917,1.231,10.652-.176c2.706-1.393,3.457-7.641,6.384-8.6,2.882-.944,7.121,3.657,10.183,3.173,2.975-.473,5.6-6.179,8.715-6.179s5.737,5.706,8.719,6.179c3.055.484,7.295-4.117,10.174-3.173,2.931.962,3.682,7.208,6.386,8.6,2.74,1.409,8.19-1.635,10.65.178,2.477,1.82,1.28,7.992,3.446,10.174s8.275.973,10.074,3.473-1.22,7.988.176,10.752c1.382,2.729,7.568,3.486,8.521,6.446.933,2.9-3.626,7.188-3.146,10.272C117.843,57.159,123.5,59.812,123.5,62.95Z",
    transform: "translate(1.527 1.527)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.a52c85ca2d4a3fc9a57a33dc9c1e50cc.svg";
export { ForwardRef as ReactComponent };